import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';

import { AppComponent } from './app.component';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AuthService } from './auth/auth.service';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { GraphQLModule } from '../graphql/graphql.module';
import { HttpClientModule } from '@angular/common/http';
import { LastActiveService } from './shared/services/last-active.class';
import { BiometricService } from './shared/services/capacitor-biometric.class';
import { navigationAnimation } from './shared/animations/nav-animation';
import { MqttConnectorModule } from 'src/mqtt/mqtt-connector.module';
import { IonicStorageModule } from '@ionic/storage-angular';
import { TwoNService } from './services/two-n.service';
import { DynamoDBService } from './services/dynamodb.service';
import { SharedModule } from './shared/shared.module';
import { DeviceCacheService } from 'src/mqtt/services/device-cache.service';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot({
      menuType: 'overlay',
      rippleEffect: false,
      mode: 'ios',
      navAnimation: navigationAnimation,
    }),
    FormsModule,
    AppRoutingModule,
    GraphQLModule,
    MqttConnectorModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    SharedModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    AuthService,
    BiometricService,
    TwoNService,
    DynamoDBService,
    IonicRouteStrategy,
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [LastActiveService],
      useFactory: (lastActiveService: LastActiveService) => () =>
        lastActiveService.setUp(),
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [DeviceCacheService],
      useFactory: (deviceCacheService: DeviceCacheService) => () => {
        // Ensure cache is fully initialized before Angular continues
        return new Promise<void>((resolve) => {
          // Give cache a moment to initialize in case it hasn't yet
          deviceCacheService.initializeCachedStates();
          // Add small delay to ensure message storage is updated
          setTimeout(() => {
            resolve();
          }, 10);
        });
      }
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
